import React from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_ALIGN,
} from '@gcloud-npm/next12.components.text-info-n';
import Icon, { ICON_COLOR } from '@gcloud-npm/next12.components.icon-n';

import styles from './styles';

const Charac = ({ icon, label, description, iconProps }) => {
  return (
    <>
      <div className="Charac">
        {icon && (
          <Icon
            className="Charac_icon"
            id={icon || ''}
            color={iconProps.iconColor || ICON_COLOR.BLUE_DARK1}
            size={iconProps.iconSize || 36}
            layoutSize={{
              w: iconProps.iconSize || 36,
              h: iconProps.iconSize || 36,
            }}
          />
        )}
        {label && (
          <TextInfo
            className="Charac_label"
            color={TEXT_INFO_COLOR.BLUE_DARK1}
            fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
            size={TEXT_INFO_SIZE.TITLE5}
            text={label}
            kind={TEXT_INFO_KIND.SPAN}
            align={TEXT_INFO_ALIGN.CENTER}
          />
        )}
        {description && (
          <TextInfo
            className="Charac_description"
            color={TEXT_INFO_COLOR.GREY_4}
            fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
            size={TEXT_INFO_SIZE.TITLE7}
            text={description}
            kind={TEXT_INFO_KIND.SPAN}
            align={TEXT_INFO_ALIGN.CENTER}
          />
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Charac.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  iconProps: PropTypes.object,
};

Charac.defaultProps = {
  icon: '',
  label: '',
  description: '',
  iconProps: {},
};

export default Charac;
